const configuracaoBanco = new Map();

configuracaoBanco.set('global', {
  carteira: 5,
  agencia: 10,
  conta: 10,
  numeroContrato: 10,
  nossoNumero: 11,
  cnab400: false,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Bradesco
configuracaoBanco.set('237', {
  carteira: 2,
  agencia: 4,
  conta: 7,
  numeroContrato: 7,
  nossoNumero: 11,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: true,
  possuiPix: true,
});

// Banco do Brasil
configuracaoBanco.set('001', {
  carteira: 2,
  agencia: 4,
  conta: 8,
  numeroContrato: 7,
  nossoNumero: 10,
  cnab400: true,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Itaú
configuracaoBanco.set('341', {
  carteira: 3,
  agencia: 4,
  conta: 5,
  numeroContrato: 7,
  nossoNumero: 8,
  cnab400: true,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: true,
  possuiPix: true,
});

// Santander
configuracaoBanco.set('033', {
  carteira: 1,
  agencia: 4,
  conta: 8,
  numeroContrato: 7,
  nossoNumero: 7,
  cnab400: true,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Sicoob
configuracaoBanco.set('756', {
  carteira: 1,
  agencia: 4,
  conta: 8,
  numeroContrato: 10,
  nossoNumero: 7,
  cnab400: true,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: true,
  possuiPix: false,
});

// BRB
configuracaoBanco.set('070', {
  carteira: 2,
  agencia: 3,
  conta: 6,
  numeroContrato: 10,
  nossoNumero: 6,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Caixa
configuracaoBanco.set('104', {
  carteira: 1,
  agencia: 4,
  conta: 9,
  numeroContrato: 7,
  nossoNumero: 15,
  cnab400: false,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Sicredi
configuracaoBanco.set('748', {
  carteira: 1,
  agencia: 6,
  conta: 5,
  numeroContrato: 5,
  nossoNumero: 6,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Cecred
configuracaoBanco.set('085', {
  carteira: 1,
  agencia: 4,
  conta: 7,
  numeroContrato: 6,
  nossoNumero: 9,
  cnab400: false,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Banrisul
configuracaoBanco.set('041', {
  carteira: 1,
  agencia: 4,
  conta: 9,
  numeroContrato: 9,
  nossoNumero: 8,
  cnab400: true,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Unicred
configuracaoBanco.set('136', {
  carteira: 3,
  agencia: 4,
  conta: 9,
  numeroContrato: 9,
  nossoNumero: 10,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Inter
configuracaoBanco.set('077', {
  carteira: 3,
  agencia: 4,
  conta: 8,
  numeroContrato: 8,
  nossoNumero: 10,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
});

// Cresol
configuracaoBanco.set('133', {
  carteira: 2,
  agencia: 4,
  conta: 7,
  numeroContrato: 7,
  nossoNumero: 11,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

// Banese
configuracaoBanco.set('047', {
  carteira: 1,
  agencia: 2,
  conta: 6,
  numeroContrato: 5,
  nossoNumero: 8,
  cnab400: false,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

//Banestes
configuracaoBanco.set('021', {
  carteira: 1,
  agencia: 3,
  conta: 11,
  numeroContrato: 5,
  nossoNumero: 8,
  cnab400: true,
  cnab240: true,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

//Uniprime
configuracaoBanco.set('084', {
  carteira: 2,
  agencia: 4,
  conta: 7,
  numeroContrato: 7,
  nossoNumero: 11,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

//Mercantil do Brasil
configuracaoBanco.set('389', {
  carteira: 2,
  agencia: 4,
  conta: 9,
  numeroContrato: 9,
  nossoNumero: 10,
  cnab400: true,
  cnab240: false,
  cnab400Bordero: false,
  cnab240Bordero: false,
  possuiPix: false,
});

export default configuracaoBanco;
